<div class="spinner-container">
    <div class="custom-spinner" [style.filter]="isNotificationLoader ? 'brightness(7.5)' : 'none'">
        <div class="spinner-blade" *ngFor="let blade of blades"></div>
    </div>
</div>